import { render, staticRenderFns } from "./LifebuoyIcon.vue?vue&type=template&id=27ab1788&scoped=true&"
import script from "./LifebuoyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LifebuoyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab1788",
  null
  
)

export default component.exports